import { useMemo } from 'react';
import isNil from 'lodash/isNil';
import { useSelector } from 'react-redux';
import { amountSum } from '../commonUtils';
import getCurrentAmountAndCreditBalance from './getCurrentAmountAndCreditBalance';

export default function useCurrentAmountAndCreditBalance() {
  const {
    entities: {
      orderInfo: {
        thirdPartyAmount, totalAmount,
      } = {},
    },
  } = useSelector(state => state.mainStateData);

  const paymentOptions = useSelector(state => state.paymentOptions);
  if (!paymentOptions) { // cof have no paymentoption
    return { yourPayment: totalAmount, currentCreditBalance: 0 };
  }

  const {
    amountDue,
    creditBalance,
    useCreditBalance,
    paymentProcessingFee,
    futurePaymentProcessingFeeAmount,
  } = paymentOptions;

  const { currentCreditBalance, currentAmountDue } = useMemo(() => {
    return getCurrentAmountAndCreditBalance({
      useCreditBalance,
      creditBalance,
      currentTotalAmount: isNil(amountDue) ? 0 : amountDue,
      thirdPartyAmount,
    });
  }, [ useCreditBalance, creditBalance, thirdPartyAmount, amountDue ]);

  const yourPayment = useMemo(() => {
    return amountSum(currentAmountDue, paymentProcessingFee);
  }, [ currentAmountDue, paymentProcessingFee ]);

  return {
    yourPayment, currentCreditBalance, useCreditBalance, paymentProcessingFee, futurePaymentProcessingFeeAmount,
  };
}
